/* eslint-disable no-unused-vars */
import { connect } from 'react-redux';
/* eslint-disable no-unused-vars */
import i18next from 'i18next';
import QueryString from 'query-string';
import React from 'react';
import ReactTable from 'react-table';
import { Redirect } from 'react-router-dom';
import ScrollArea from 'react-scrollbar';
import ui from 'redux-ui';

import { AccessHelper, BaseTable } from '../../helpers';
import {
  AssetsService,
  GroupingsService,
  TagsService
} from '../../services';
import { RowButton } from '../RowButton';
import { ScrollModule } from '../ScrollModule';
import { SelectInput } from '../SelectInput';

@ui({
  key: 'assets-list',
  persist: true,
  state: {
    selectedGrouping: null,
    selectedArea: null,
    selectedTag: null,
    prevPage: null
  }
})
@connect(state => ({
  me: state.user.me,
  currentGrouping: state.currentGrouping.currentGrouping
}))
class AssetList extends React.Component {

  constructor(props) {
    super(props);

    const passedState = this.props.currLocation ? this.props.currLocation.state : null;

    this.DEFAULT_SORTED = [{ id: 'name', desc: true }];

    this.refresh = this.refresh.bind(this);    
    this.datafetched = this.datafetched.bind(this);
    this.makeDatatableRequest = this.makeDatatableRequest.bind(this);
    this.updateRequestURL = this.updateRequestURL.bind(this);
    this.getForcePage = this.getForcePage.bind(this);
    this.doSearch = this.doSearch.bind(this);

    this.updateSelectedGrouping = this.updateSelectedGrouping.bind(this);
    this.updateSelectedArea = this.updateSelectedArea.bind(this);
    this.updateSelectedTag = this.updateSelectedTag.bind(this);

    const parsedOptions = QueryString.parse(this.props.currLocation.search);

    this.state = {
      hasError: false,
      data: [],
      pageCount: null,
      forcePage: null,
      loading: true,
      totalElements: null,
      filtered: [],
      timeout: 0,
      linkTo: null,
      localErrorHandler: this.props.localErrorHandler,
      groupingFilterOptions: passedState ? passedState.groupingFilterOptions : null,
      areaFilterOptions: passedState ? passedState.areaFilterOptions : null,
      tagFilterOptions: passedState ? passedState.tagFilterOptions : null,
      selectedGrouping: passedState ? passedState.currentGroupingFilter : null,
      selectedArea: passedState ? passedState.currentAreaFilter : null,
      selectedTag: passedState ? passedState.currentTagFilter : null,
      searchValue: passedState && passedState.searchValue ? passedState.searchValue : '',
      currentHistoryCount: passedState && passedState.currentHistoryCount ? passedState.currentHistoryCount : 0,
      parsedOptions,
      viewAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/assets/view/:assetId'),
      editAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/config/assets/edit/:assetId')
    };
  }

  componentDidMount() {
    const parsedOptions = this.state.parsedOptions ? this.state.parsedOptions : {};
    if (this.state.groupingFilterOptions == null) {
      if (this.props.me.adhocRoleAssignment) {
        setTimeout(() => {
          const groupingFilterOptions = [{
            label: null,
            options: this.props.me.availableGroupings.map(grouping => ({
              fqn: grouping.fullyQualifiedName,
              label: grouping.name,
              value: `${grouping.id}`
            }))
          }];
          let selectedGrouping = null;
          if (this.state.selectedGrouping) {
            selectedGrouping = this.state.selectedGrouping;
          } else if (parsedOptions.filterByGroupingIds) {
            selectedGrouping = groupingFilterOptions[0].options
              .filter(grouping => grouping.value === parsedOptions.filterByGroupingIds);
          }
          this.setState({
            groupingFilterOptions,
            selectedGrouping
          });
        }, 100);
      } else {
        GroupingsService.getAllWithAccess(this.props.currentGrouping.id).then((response) => {
          const groupingFilterOptions = response.groupings;
          let selectedGrouping = null;
          if (this.state.selectedGrouping) {
            selectedGrouping = this.state.selectedGrouping;
          } else if (parsedOptions.filterByGroupingIds) {
            const filteredGrouping = response.groupings.filter(group =>
              group.options.filter(grouping => grouping.value === parsedOptions.filterByGroupingIds))
              .flatMap((group) => {
                const newGroup = Object.assign({}, group);
                return newGroup.options
                  .filter(grouping => grouping.value === parsedOptions.filterByGroupingIds);
              });
            selectedGrouping = filteredGrouping[0].value;
          }
          this.setState({
            groupingFilterOptions,
            selectedGrouping
          });
        }).catch((error) => {
          console.error(error);
          this.state.localErrorHandler(error.message);
        });
      }
    }
    if (this.state.tagFilterOptions == null) {
      TagsService.listAll().then((response) => {
        let selectedArea = null;
        if (this.state.selectedArea) {
          selectedArea = this.state.selectedArea;
        } else if (parsedOptions.filterByAreaIds) {
          selectedArea = response.tags.filter(tag => tag.id.toString() === parsedOptions.filterByAreaIds)[0].id;
        }
        let selectedTag = null;
        if (this.state.selectedTag) {
          selectedTag = this.state.selectedTag;
        } else if (parsedOptions.filterByTagIds) {
          selectedTag = response.tags.filter(tag => tag.id.toString() === parsedOptions.filterByTagIds)[0].id;
        }
        this.setState({
          selectedArea,
          selectedTag,
          tagFilterOptions: this.mapTagOptions(response.tags.filter(tag => tag.tagType && tag.tagType.token !== 'area')),
          areaFilterOptions: this.mapTagOptions(response.tags.filter(tag => tag.tagType && tag.tagType.token === 'area'))
        });
      }).catch((error) => {
        console.error(error);
        this.setState({ errorMessage: i18next.t('messages.could-not-load-tags-view') });
      });
    }    
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props !== prevProps && this.props.refresh) {
      this.fetchData(this.assetsTable && this.assetsTable.state ? this.assetsTable.state : null);
    }
  }

  getAssets(options, curSearch, callback) {
    this.updateOptions(options);
    AssetsService.getAll(options).then((response) => {
      this.props.finishedRefresh();
      if (curSearch === this.state.searchValue) {
        const pageCount = Math.ceil(response.page.totalElements / this.assetsTable.state.pageSize);
        const forcePage = this.getForcePage(pageCount);
        callback({
          data: response.assets,
          pageCount,
          forcePage,
          searchValue: curSearch,
          recordsTotal: response.page.totalElements
        });
      }
    }).catch((error) => {
      console.error(error);
      this.props.finishedRefresh();
      this.setState({ hasError: true });
      callback({ data: [], recordsTotal: 0, recordsFiltered: 0 });
      this.state.localErrorHandler(error.message);
    });
  }

  getForcePage(pageCount) {
    let forcePage = null;
    if (this.assetsTable && this.assetsTable.state && this.assetsTable.state.page >= pageCount && pageCount > 0) {
      forcePage = pageCount - 1;
    }
    return forcePage;
  }

  updateOptions(options) {    
    if (this.state.selectedGrouping) {
      if (this.state.selectedGrouping.length === 0) {
        options.push({ filterByGroupingIds: [-1] });
      } else {
        options.push({ filterByGroupingIds: this.state.selectedGrouping });
      }
    }
    if (this.state.selectedArea) {
      if (this.state.selectedArea.length === 0) {
        options.push({ filterByAreaIds: [-1] });
      } else {
        options.push({ filterByAreaIds: this.state.selectedArea });
      }
    }
    if (this.state.selectedTag) {
      if (this.state.selectedTag.length === 0) {
        options.push({ filterByTagIds: [-1] });
      } else {
        options.push({ filterByTagIds: this.state.selectedTag });
      }
    }
  }

  makeDatatableRequest(data, callback) {
    if (this.state.hasError) {
      return;
    }
    const apiOptions = this.state.parsedOptions;
    const options = BaseTable.buildFetchDataOptions(apiOptions, this.DEFAULT_SORTED);
    const curSearch = this.state.searchValue;

    if (this.state.searchValue) {
      options.push({ search: this.state.searchValue });
    }

    options.push({ includeArchived: false });

    this.getAssets(options, curSearch, callback);
  }

  mapTagOptions(tags) {
    return tags.sort((a, b) => {
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      } else if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      }
      return 0;
    }).map(tag => ({ label: tag.name, value: tag.id }));
  }

  fetchData(tableData) {
    if (this.updateRequestURL(tableData)) {
      return;
    }

    this.setState({
      loading: true
    });

    this.makeDatatableRequest(tableData, this.datafetched, null);
  }

  datafetched(res) {
    if (this.state.searchValue && res.search && res.search !== this.state.searchValue) {
      // not current request
      return;
    }

    this.setState({
      data: res.data,
      pageCount: res.pageCount,
      forcePage: res.forcePage,
      loading: false,
      totalElements: res.recordsTotal
    });
  }

  refresh() {
    this.updateRequestURL(this.assetsTable && this.assetsTable.state ? this.assetsTable.state : null);
  }

  updateSelectedGrouping({ value }) {
    this.setState({
      selectedGrouping: value
    }, () => {
      this.refresh();
    });
  }

  updateSelectedArea({ value }) {
    this.setState({
      selectedArea: value
    }, () => {
      this.refresh();
    });
  }

  updateSelectedTag({ value }) {
    this.setState({
      selectedTag: value
    }, () => {
      this.refresh();
    });
  }

  updateSearchValue(val) {
    this.setState({ searchValue: val }, () => {
      this.fetchData(this.assetsTable && this.assetsTable.state ? this.assetsTable.state : null);
    });
  }

  doSearch(val) {
    const value = val.target.value;
    this.setState({ searchValue: value });
    if (this.state.timeout) {
      clearTimeout(this.state.timeout);
    }
    this.state.timeout = setTimeout(() => {
      this.updateSearchValue(value);
    }, 500);
  }

  updateRequestURL(tableData) {
    const options = BaseTable.buildURLOptions(tableData, this.DEFAULT_SORTED);
    this.updateOptions(options);

    const params = options.map(option => Object.keys(option).map(k => `${k}=${option[k]}`)).join('&');

    const currentSearch = this.props.currLocation.search ? this.props.currLocation.search : '?';

    if (`?${params}` !== currentSearch) {
      if (this.state.currentHistoryCount > 100) {
        console.error('Exceeded the history count stack of 100.');
        return false;
      }
      this.props.pushHistory({
        search: `?${params}`,
        state: {
          currentHistoryCount: this.state.currentHistoryCount + 1,
          currentGroupingFilter: this.state.selectedGrouping,
          currentAreaFilter: this.state.selectedArea,
          currentTagFilter: this.state.selectedTag,
          searchValue: this.state.searchValue
        }
      });
      return true;
    }
    return false;
  }

  renderArea(data) {
    if (data.original.tags) {
      const areaTag = data.original.tags.find(tag => tag.tagType.token == 'area');
      if (areaTag) {
        return (<span className="selected-tag-text">{areaTag.name}</span>);
      }
    }
    return '';    
  }

  renderTags(data) {
    if (data.original.tags) {
      return (
        <div className="selected-tags">
          {data.original.tags.filter(tag => tag.tagType.token != 'area').map(tag =>
            (
              <div className="selected-tag" key={tag.id}>
                <span className="selected-tag-text">{tag.name}</span>
              </div>
            )
          )}
        </div>
      );
    }
    return '';
  }

  render() {
    const {
      data,
      pageCount,
      loading,
      totalElements,
      groupingFilterOptions,
      areaFilterOptions,
      tagFilterOptions,
      selectedGrouping,
      selectedArea,
      selectedTag
    } = this.state;

    if (this.state.linkTo) {
      return (<Redirect
        push
        to={{
          pathname: this.state.linkTo,
          state: {
            backLinkSearch: this.props.currLocation.search,
            searchValue: this.state.searchValue
          }
        }}
      />);
    }

    const dynamicOptions = BaseTable.buildDynamicOptions(this.state.parsedOptions, this.state.forcePage, this.DEFAULT_SORTED);

    if (groupingFilterOptions && tagFilterOptions && areaFilterOptions) {
      return (
        <div className="asset-list">
          <ScrollModule />
          <ScrollArea
            speed={0.8}
            className="scroll-container"
            contentClassName="scrollable-content"
            horizontal
          >
            <div className="react-table-custom">
              <ReactTable
                getTheadFilterThProps={(state, rowInfo, column) => ({ style: { overflow: 'visible' } })}
                className="-striped -highlight"
                ref={(el) => { this.assetsTable = el; }}
                manual
                data={data}
                pages={pageCount} // Display the total number of pages
                loading={loading} // Display the loading overlay when we need it
                onFetchData={this.fetchData.bind(this)} // Request new data when things change
                totalElements={totalElements}
                showPaginationTop
                style={{ paginationTop: { width: '200px' } }}
                customButtons={[
                  { label: i18next.t('pages.assets.add-asset'), method: () => { this.setState({ linkTo: `/config/assets/add` }) } }
                ]}
                defaultSorted={this.DEFAULT_SORTED}
                columns={[
                  {
                    Header: i18next.t('table-headers.asset-name'),
                    id: 'name',
                    accessor: 'name',
                    Cell: cell => <span>{ cell.value }</span>,
                    sortable: false,
                    minResizeWidth: 50,
                    filterable: true,
                    Filter: 
                    <div className="filter">
                      <i className="table-search-icon" />
                      <input
                        style={{ width: '100%', margin: '0 auto' }}
                        value={this.state.searchValue}
                        onChange={this.doSearch}
                        type="text"
                        name="search"
                        className="table-search-box"
                        autoComplete="off"
                      />
                    </div>
                  },                  
                  {
                    Header: i18next.t('table-headers.group'),
                    id: 'businessGroup',
                    accessor: 'businessGroup',
                    Cell: cell => <span>{ cell.value.name }</span>,
                    sortable: false,
                    minResizeWidth: 50,
                    filterable: true,
                    Filter: () => (
                      <div className="filter select-filter">
                        <SelectInput
                          name="deviceGrouping"
                          input={{
                            value: groupingFilterOptions.map(optionCat => optionCat.options.find(option => option.value === selectedGrouping)),
                            onChange: this.updateSelectedGrouping
                          }}
                          options={[ { label: i18next.t('show-all'), value: '' } ].concat(groupingFilterOptions)}
                          isSearchable
                          meta={{}}
                          filterGroupHeading
                          placeholder={i18next.t('show-all')}
                        />
                      </div>
                    )
                  },
                  {
                    Header: i18next.t('table-headers.area'),
                    accessor: 'area',
                    Cell: row => (this.renderArea(row)),
                    sortable: false,
                    minResizeWidth: 50,
                    filterable: true,
                    Filter: () => (
                      <div className="filter select-filter">
                        <SelectInput
                          name="area"
                          input={{
                            value: areaFilterOptions.find(option => option.value === selectedArea),
                            onChange: this.updateSelectedArea
                          }}
                          options={[ { label: i18next.t('show-all'), value: '' } ].concat(areaFilterOptions)}
                          isSearchable
                          meta={{}}
                          placeholder={i18next.t('show-all')}
                        />
                      </div>
                    )
                  },
                  {
                    Header: i18next.t('table-headers.tags'),
                    id: 'assetTag',
                    accessor: 'tags',
                    Cell: row => (this.renderTags(row)),
                    sortable: false,
                    minResizeWidth: 50,
                    filterable: true,
                    Filter: () => (
                      <div className="filter select-filter">
                        <SelectInput
                          name="tags"
                          input={{
                            value: tagFilterOptions.find(option => option.value === selectedTag),
                            onChange: this.updateSelectedTag
                          }}
                          options={[ { label: i18next.t('show-all'), value: '' } ].concat(tagFilterOptions)}
                          isSearchable
                          meta={{}}
                          placeholder={i18next.t('show-all')}
                        />
                      </div>
                    )
                  },
                  {
                    Cell: cell => (<RowButton
                      allowView={this.state.viewAllowed}
                      allowEdit={this.state.editAllowed}
                      viewPath={{
                        pathname: `/config/assets/view/${cell.original.id}`,
                        state: {
                          backLinkSearch: this.props.currLocation.search,
                          searchValue: this.state.searchValue
                        }
                      }}
                      editPath={{
                        pathname: `/config/assets/edit/${cell.original.id}`,
                        state: {
                          backLinkSearch: this.props.currLocation.search,
                          searchValue: this.state.searchValue
                        }
                      }}
                    />),
                    sortable: false,
                    minResizeWidth: 50,
                    width: 150
                  }
                ]}
                {...dynamicOptions}
              />
            </div>

          </ScrollArea>

        </div>
      );
    }
    return (
      <div className="loader">{ i18next.t('loading') }</div>
    );
  }
}

export default AssetList;
